import { render, staticRenderFns } from "./deliveryPerformance.vue?vue&type=template&id=1b5f1090&"
import script from "./deliveryPerformance.vue?vue&type=script&lang=js&"
export * from "./deliveryPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports